var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog-label",
          staticStyle: { "margin-top": "5vh" },
          attrs: {
            title: this.diaTitle,
            visible: _vm.show,
            "modal-append-to-body": false,
            width: "600px",
            height: "400px",
            "close-on-click-modal": false,
            "before-close": _vm.cancelHandle
          },
          on: {
            "update:visible": function($event) {
              _vm.show = $event
            }
          }
        },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              clearable: "",
              autocomplete: "off",
              size: "small",
              maxlength: "200",
              "show-word-limit": "",
              rows: 6
            },
            model: {
              value: _vm.welcomeContent,
              callback: function($$v) {
                _vm.welcomeContent = $$v
              },
              expression: "welcomeContent"
            }
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.cancelHandle()
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.confirmHandle()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }